import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import type { ElementType } from 'react';
import { NavLink as NLink } from 'react-router-dom';

interface NavLinkProps {
  icon?: ElementType;
  link: string;
  title?: string;
  count?: number;
  isCollapsed?: boolean;
  testID?: string;
  isCustomActive?: boolean;
  /**
   * The user is heading for this link (hover, focus, touch): a page can start
   * its code and data here so they are under way before the click lands.
   */
  onIntent?: () => void;
}

export const NavLink = ({
  icon,
  link,
  title,
  count = 0,
  isCollapsed,
  testID = 'nav-link',
  isCustomActive = false,
  onIntent,
}: NavLinkProps) => {
  return (
    <Tooltip
      isDisabled={!isCollapsed}
      label={title}
      arrowSize={8}
      hasArrow
      placement="right"
      borderRadius="4px"
      variant="default"
    >
      <NLink
        to={link}
        onMouseEnter={onIntent}
        onFocus={onIntent}
        onTouchStart={onIntent}
        className={(isActive) =>
          'app-nav' + (isActive || isCustomActive ? ' active' : '')
        }
      >
        <Flex
          className="nav"
          alignItems="center"
          justifyContent="space-between"
          cursor="pointer"
          p="8px 12px"
          mb="2px"
          borderRadius="6px"
          _hover={{ bg: 'white' }}
          minHeight="42px"
        >
          <Flex alignItems="center">
            <Icon
              as={icon}
              width="18px"
              height="18px"
              color={'primary-900'}
              strokeWidth={1.2}
              mr="10px"
              data-test-id={`${testID}-icon`}
            />
            {!isCollapsed && (
              <Text
                flex="1"
                fontSize="14px"
                fontWeight="regular"
                whiteSpace="nowrap"
                color={'primary-900'}
                data-test-id={testID}
              >
                {title}
              </Text>
            )}
          </Flex>
          {isCollapsed && count > 0 && (
            <Box
              bg="#444CE7"
              padding="3px"
              borderRadius="100%"
              position="relative"
              left="-8px"
              top="-3px"
            ></Box>
          )}
          {!isCollapsed && count > 0 && (
            <Flex
              px="8px"
              py="4px"
              h="20px"
              w={count / 100 >= 1 ? 'fit-content' : '20px'}
              borderRadius={count / 100 >= 1 ? '16px' : '100%'}
              fontSize="xs"
              alignItems="center"
              justifyContent="center"
              bg={'primary-100'}
              color={'primary-700'}
              fontWeight="semiBold"
            >
              {count}
            </Flex>
          )}
        </Flex>
      </NLink>
    </Tooltip>
  );
};
